import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType, gettext } from '@eventbrite/i18n';
import { withTooltip } from '@eventbrite/eds-tooltip';
import { IconButton } from '@eventbrite/eds-icon-button';
import { Icon } from '@eventbrite/eds-icon';
import { CrossChunky } from '@eventbrite/eds-iconography';
import {
    STYLE_PROP_TYPE as ICON_BUTTON_STYLE_PROPTYPE,
    ICON_PROP_TYPE as ICON_BUTTON_ICON_PROPTYPE,
} from '@eventbrite/eds-icon-button';

const EventCardLikeTooltip = withTooltip(({ children }) => children);
const EventCardAction = ({
    iconType,
    style,
    title,
    secondary,
    onClick,
    isListCard,
    showLikesTooltip,
    onCloseLikesTooltip,
    onShowLikesTooltip,
}) => {
    let component = null;
    const iconClassName = classNames(
        'eds-event-card-content__actions-container__action',
        {
            'eds-l-pad-all-1': !isListCard,
            'eds-l-mar-right-2': !!secondary && !isListCard,
            'eds-event-card-content__actions-icon--primary': !secondary,
            'eds-event-card-content__actions-icon--secondary': !!secondary,
        },
    );

    if (iconType) {
        if (showLikesTooltip) {
            component = (
                <EventCardLikeTooltip
                    tooltipId="eds-event-card-content__actions-likes-tooltip"
                    className="eds-event-card-content__actions-likes-tooltip"
                    keepTooltipOpen
                    manuallyToggleTooltip
                    renderOnMount
                    onShowTooltip={onShowLikesTooltip}
                    tooltipArrowLocation="right"
                    tooltipStyle="phab"
                    tooltipText={
                        <div onClick={(e) => e.stopPropagation()}>
                            <p className="eds-event-card-content__actions-likes-tooltip__title">
                                {gettext('Find more events you love')}
                            </p>
                            <p>
                                {gettext(
                                    'Like events to help us give you better event recommendations.',
                                )}
                            </p>
                            <a
                                className="eds-event-card-content__actions-likes-tooltip__close"
                                onClick={onCloseLikesTooltip}
                            >
                                <Icon type={<CrossChunky />} />
                            </a>
                        </div>
                    }
                >
                    <span className={iconClassName}>
                        <IconButton
                            title={title}
                            style={style}
                            iconType={iconType}
                            onClick={onClick}
                        />
                    </span>
                </EventCardLikeTooltip>
            );
        } else {
            component = (
                <span className={iconClassName}>
                    <IconButton
                        title={title}
                        style={style}
                        iconType={iconType}
                        onClick={onClick}
                    />
                </span>
            );
        }
    }

    return component;
};

export default class EventCardActions extends PureComponent {
    static propTypes = {
        primaryIconType: ICON_BUTTON_ICON_PROPTYPE,
        primaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
        primaryIconTitle: translationPropType,
        primaryIconOnClick: PropTypes.func,
        secondaryIconType: ICON_BUTTON_ICON_PROPTYPE,
        secondaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
        secondaryIconTitle: translationPropType,
        secondaryIconOnClick: PropTypes.func,
        shouldShowIcons: PropTypes.bool,
        isListCard: PropTypes.bool,
        showLikesTooltip: PropTypes.bool,
        onCloseLikesTooltip: PropTypes.func,
        onShowLikesTooltip: PropTypes.func,
    };

    render() {
        const {
            primaryIconType,
            primaryIconStyle,
            primaryIconTitle,
            primaryIconOnClick,
            secondaryIconType,
            secondaryIconStyle,
            secondaryIconTitle,
            secondaryIconOnClick,
            isListCard,
            shouldShowIcons,
            showLikesTooltip,
            onCloseLikesTooltip,
            onShowLikesTooltip,
        } = this.props;
        const classes = classNames(
            'eds-event-card-content__actions-container eds-event-card-content__actions-container--consumer',
            {
                'eds-event-card-content__actions-container--always-visible': shouldShowIcons,
            },
        );

        return (
            <div className={classes}>
                <EventCardAction
                    iconType={secondaryIconType}
                    style={secondaryIconStyle}
                    title={secondaryIconTitle}
                    onClick={secondaryIconOnClick}
                    secondary={secondaryIconType}
                    isListCard={isListCard}
                    showLikesTooltip={showLikesTooltip}
                    onCloseLikesooltip={onCloseLikesTooltip}
                    onShowLikesTooltip={onShowLikesTooltip}
                />

                <EventCardAction
                    iconType={primaryIconType}
                    style={primaryIconStyle}
                    title={primaryIconTitle}
                    onClick={primaryIconOnClick}
                    isListCard={isListCard}
                    showLikesTooltip={showLikesTooltip}
                    onCloseLikesTooltip={onCloseLikesTooltip}
                    onShowLikesTooltip={onShowLikesTooltip}
                />
            </div>
        );
    }
}
